import React from 'react';
import Location from '../components/locations/Locations';
import { hasPermission } from '../components/auth/login/Login';
import { useNavigate } from 'react-router-dom';

const LocationPage = () => {

    const canReadProperty = hasPermission("Properties & Units", "Property", "read");
    const navigate = useNavigate();

    if (!canReadProperty) {
        navigate('/no-permission')
    }

    return (
        <div>
            <Location />
        </div>
    );
};

export default LocationPage;
